export enum BlueMediaSearchParam {
  OrderId = 'OrderID',
  Hash = 'Hash',
  serviceID = 'ServiceID',
}
